import PropTypes from 'prop-types'
/* import { ROLES } from '../../config/user' */
import Download from 'mdi-material-ui/Download'
import { Button, Switch } from '@material-ui/core'
/* import { useSession } from '../../../src/context/SessionContext' */
// import Button from './Button'
// import RotateRight from 'mdi-material-ui/RotateRight'

/**
 * Custom `PreviewBarRight` component declaration.
 * This component integrates functionalities for download and change watermark
 * @param {Function} onRotate 
 * @param {Function} onDownloadWord 
 * @param {Function} onDownload 
 * @param {Function} changeStateWatermark
 * @param {Boolean} hidden
 * @return PreviewBarRight
 */
const PreviewBarRight = (props: any) => {
  /* const { user } = useSession() */
  const label = { inputProps: { 'aria-label': 'Switch demo' } };

  if (props.hidden) {
    return null
  }

  return (
    <div>
      {/* <Button onClick={props.onRotate}>
        <RotateRight />
      </Button> */}

      Membrete: 
      <Switch onClick={props.changeStateWatermark} {...label} defaultChecked color="primary" />

      {/* {user && user.role === ROLES.SUPER_USER 
        ? 
          <Button onClick={props.onDownloadWord}>
            Word <Download />
          </Button>
        :
          <></>
      } */}
      
      <Button onClick={props.onDownload}>
        Descargar PDF <Download />
      </Button>
    </div>
  )
}

PreviewBarRight.propTypes = {
  onRotate: PropTypes.func.isRequired,
  onDownloadWord: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  changeStateWatermark: PropTypes.func.isRequired,
  hidden: PropTypes.bool,
}

export default PreviewBarRight